export default __webpack_public_path__ + "static/media/cas4.5944385d.png";